import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04fc80a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sr-only" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xs-12 col-lg-6" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "overlay-toolbar" }
const _hoisted_6 = ["id", "name"]
const _hoisted_7 = ["aria-label", "for"]
const _hoisted_8 = ["id", "name"]
const _hoisted_9 = ["aria-label", "for"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "col-xs-12 col-lg-6" }
const _hoisted_13 = { class: "q-py-md" }
const _hoisted_14 = { class: "map-skiplink" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "svg-container" }
const _hoisted_17 = ["id"]
const _hoisted_18 = ["id"]
const _hoisted_19 = ["id", "alt"]
const _hoisted_20 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_legend_table = _resolveComponent("legend-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_spinner, { loaded: _ctx.loaded }, null, 8, ["loaded"]),
    _createElementVNode("div", null, [
      _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.header), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(_ctx.text), 1),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: 'objecttypen' + _ctx.bronhouderType,
                name: 'overlay-' + _ctx.bronhouderType,
                value: "objecttypen",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentMode) = $event)),
                checked: ""
              }, null, 8, _hoisted_6), [
                [_vModelRadio, _ctx.currentMode]
              ]),
              _createElementVNode("label", {
                "aria-label": _ctx.bronhouderType + ' kaart toont objecttypen.',
                for: 'objecttypen' + _ctx.bronhouderType
              }, "Objecttypen", 8, _hoisted_7),
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: 'kwaliteitsregimes' + _ctx.bronhouderType,
                name: 'overlay-' + _ctx.bronhouderType,
                value: "kwaliteitsregimes",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentMode) = $event))
              }, null, 8, _hoisted_8), [
                [_vModelRadio, _ctx.currentMode]
              ]),
              _createElementVNode("label", {
                "aria-label": _ctx.bronhouderType + ' kaart toont kwaliteitsregimes.',
                for: 'kwaliteitsregimes' + _ctx.bronhouderType
              }, "Kwaliteitsregimes", 8, _hoisted_9)
            ]),
            _hoisted_10,
            _withDirectives(_createVNode(_component_legend_table, {
              data: _ctx.legendData,
              legendId: _ctx.currentMode + '-' + _ctx.bronhouderType + '-legenda'
            }, null, 8, ["data", "legendId"]), [
              [_vShow, _ctx.loaded]
            ])
          ]),
          _hoisted_11
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("a", {
                href: _ctx.currentMode == 'objecttypen'
                ? '#button-table-types-' + _ctx.bronhouderType.toLowerCase()
                : '#button-table-kwaliteitsregimes-' +
                _ctx.bronhouderType.toLowerCase()
                ,
                style: {"color":"#ffffff"}
              }, " Spring focus over de kaart heen ", 8, _hoisted_15)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(), _createElementBlock("svg", {
              id: 'bronhoudermap-' + _ctx.bronhouderType
            }, null, 8, _hoisted_17)),
            _createElementVNode("div", {
              class: "tooltip-container",
              id: 'ttcontainer-' + _ctx.bronhouderType,
              style: {"display":"none"},
              "aria-hidden": "true"
            }, null, 8, _hoisted_18)
          ])
        ], 512), [
          [_vShow, _ctx.loaded]
        ])
      ]),
      _createElementVNode("button", {
        class: "button-table assistive-button",
        id: _ctx.currentMode == 'objecttypen'
        ? 'button-table-types-' + _ctx.bronhouderType.toLowerCase()
        : 'button-table-kwaliteitsregimes-' + _ctx.bronhouderType.toLowerCase()
        ,
        alt: 'Tabel met aantal registraties per' + _ctx.bronhouderType.toLowerCase()
          ,
        ref: "toonDataTabel"
      }, " Toon datatabel ", 8, _hoisted_19),
      (_ctx.staticContent)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: _ctx.staticContent[_ctx.tblKey]
          }, null, 8, _hoisted_20))
        : _createCommentVNode("", true)
    ])
  ]))
}